<template>
    <card-seplag titulo='Cadastrar E-mail'>
        <div class="p-col-12">
            <div class="p-grid p-fluid">
                <Rotulo nome="Órgão" cols="12 4">
                    <Dropdown v-model="dropdown.orgaoSelecionado" :options="dropdown.orgaoList" option-label="descricao"
                        placeholder="Selecione uma opção..." :filter="true" />
                </Rotulo>
                <Rotulo v-if="!this.dados" nome="Assunto" cols="12 4">
                    <MultiSelect v-model="dropdown.assuntoSelecionado" :options="dropdown.assuntoList"
                        option-label="nomeAssunto" placeholder="Selecione uma opção..." :filter="true"
                        dataKey="idenAssunto" />
                </Rotulo>
                <Rotulo v-if="this.dados" nome="Assunto" cols="12 4">
                    <Dropdown v-model="dropdown.assuntoSelecionado" :options="dropdown.assuntoList"
                        option-label="nomeAssunto" placeholder="Selecione uma opção..." :filter="true"
                        dataKey="idenAssunto" />
                </Rotulo>
                <Rotulo nome="Perfil que Recebe" cols="12 4">
                    <Dropdown v-model="dropdown.perfilAcessoSelecionado" :options="dropdown.perfilAcessoList"
                        option-label="nomePerfilAcesso" placeholder="Selecione uma opção..." :filter="true" />
                </Rotulo>
            </div>
            <div class="p-col-12">
                <div class="p-grid p-fluid">
                    <Rotulo nome="E-mail" cols="12">
                        <InputText type="text" placeholder="Exemplo: Recadastramento@seplag.mt.gov.br" v-model="email"
                            v-required="true"></InputText>
                    </Rotulo>
                </div>
            </div>
        </div>

        <div class="p-col-12">
            <div class="p-grid p-fluid center">
                <Rotulo cols="12 4">
                    <Button label="Limpar" class="botao" @click="limpar()" />
                </Rotulo>
                <Rotulo cols="12 4">
                    <Button label="Salvar" class="botao" @click="salvar()" />
                </Rotulo>
            </div>
        </div>
    </card-seplag>
</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl } from "@/config/global";
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";

export default {
    components: { Rotulo, CardSeplag },

    data: function () {
        return {
            url: {
                buscarPorId: "/paramassuntoemail",
                buscarAssunto: "/assuntos/buscarAssunto",
                buscarOrgaos: "/orgaos/naoextintos",
                buscarPerfilAcesso: "/seguranca/perfilacessos",
                salvarURL: "/paramassuntoemail"
            },
            dropdown: {
                assuntoSelecionado: null,
                assuntoList: [],
                orgaoSelecionado: null,
                orgaoList: [],
                perfilAcessoSelecionado: null,
                perfilAcessoList: []
            },
            email: null,
        }
    },

    methods: {
        async carregarDados() {
            this.buscarAssuntoRequest(),
                this.buscarOrgaosExistentesRequest(),
                this.buscarPerfilAcessoRequest(),
                this.populaDadosParaEditar()
        },
        buscarAssuntoRequest() {
            this.$http.get(`${baseApiUrl}${this.url.buscarAssunto}`).then(res => {
                this.dropdown.assuntoList = res.data
            })
        },
        buscarOrgaosExistentesRequest() {
            this.$http.get(`${baseApiUrl}${this.url.buscarOrgaos}`).then(res => {
                this.dropdown.orgaoList = res.data
            })
        },
        buscarPerfilAcessoRequest() {
            this.$http.get(`${baseApiUrl}${this.url.buscarPerfilAcesso}`).then(res => {
                this.dropdown.perfilAcessoList = res.data
            })
        },
        populaDadosParaEditar() {
            if (this.dados) {
                this.dropdown.orgaoSelecionado = this.dados.orgao;
                this.dropdown.assuntoSelecionado = this.dados.assunto;
                this.dropdown.perfilAcessoSelecionado = this.dados.perfilAcesso;
                this.email = this.dados.descEmail;
            }
        },
        limpar() {
            this.dropdown.orgaoSelecionado = null;
            this.dropdown.assuntoSelecionado = null;
            this.dropdown.perfilAcessoSelecionado = null;
            this.email = null;
        },
        salvar() {
            if (this.dropdown.orgaoSelecionado == null) {
                this.$toast.add({ severity: 'error', summary: 'Erro na validação', detail: 'O Orgão deve ser informado', life: 3000 });
                return
            }
            if (this.dropdown.assuntoSelecionado == null) {
                this.$toast.add({ severity: 'error', summary: 'Erro na validação', detail: 'O assunto deve ser informado', life: 3000 });
                return
            }
            if (this.dropdown.perfilAcessoSelecionado == null) {
                this.$toast.add({ severity: 'error', summary: 'Erro na validação', detail: 'O Perfil deve ser informado', life: 3000 });
                return
            }
            if (this.email == null || !this.email.includes("@")) {
                this.$toast.add({ severity: 'error', summary: 'Erro na validação', detail: 'E-mail não informado ou Invalido', life: 3000 });
                return
            }


            let manterEmailRequest = {
                "orgao": {
                    "idenOrgao": this.dropdown.orgaoSelecionado.idenOrgao
                },
                "assunto": {
                    "idenAssunto": this.dropdown.assuntoSelecionado.idenAssunto
                },
                "perfilAcesso": {
                    "id": this.dropdown.perfilAcessoSelecionado.id
                },
                "statParamAssuntoEmail": this.dados ? (this.dados.statParamAssuntoEmail ? 1 : 0) : 1,
                "descEmail": this.email
            }

            if (this.dados) {
                this.$http.put(`${baseApiUrl}${this.url.salvarURL}/${this.dados.idenParamAssuntoEmail}`, JSON.stringify(manterEmailRequest)).then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Ação efetuada', detail: this.email + " Registro editado com sucesso", life: 5000 });
                })
            } else {
                for (let i = 0; i < this.dropdown.assuntoSelecionado.length; i++) {
                    manterEmailRequest = {
                        "orgao": {
                            "idenOrgao": this.dropdown.orgaoSelecionado.idenOrgao
                        },
                        "assunto": {
                            "idenAssunto": this.dropdown.assuntoSelecionado[i].idenAssunto
                        },
                        "perfilAcesso": {
                            "id": this.dropdown.perfilAcessoSelecionado.id
                        },
                        "statParamAssuntoEmail": this.dados ? (this.dados.statParamAssuntoEmail ? 1 : 0) : 1,
                        "descEmail": this.email
                    }
                    this.$http.post(`${baseApiUrl}${this.url.salvarURL}`, JSON.stringify(manterEmailRequest)).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Ação efetuada', detail: this.email + "Criado com sucesso para " 
                        + this.dropdown.assuntoSelecionado[i].nomeAssunto , life: 3000});
                    })
            
                }
            }
        }
    },
    computed: {
        ...mapState(['getParametroEmailEditar']),
        dados() {
            return this.$store.getters.getParametroEmailEditar;
        }
    },
    mounted() {
        this.carregarDados()

    }
}

</script>

<style scoped>
.center {
    justify-content: center;
    text-align: center;
    align-items: center;
}
</style>